import { faProjectDiagram } from "@fortawesome/free-solid-svg-icons";
import { PageConfigs } from "configs/globalInterfaces";

const name = "projects";

export const CONFIGS: PageConfigs = {
  title: name,
  path: `/${name}`,
  icon: faProjectDiagram,
  apiName: `${name}`,
  apiAddress: "projects",
  routeName: name,
  componentNames: ["project", `projects`],
  permissions: [`read:${name}`, `maintain:${name}`],
  routes: {
    all: `/${name}/*`,
    base: `/${name}`,
    list: "/list",
    add: `/add`,
    edit: `/edit/:id`,
  },
};
